import axios from "axios"
import {redirectToDashboard} from "./common"

const APP_API_URL = process.env.APP_API_URL

const handleAuthError = async (promise) => {
  try {
    const result = await promise
    return result.data
  } catch (error) {
    if (401 === error.response.status) await redirectToDashboard()
    throw error
  }
}

// eslint-disable-next-line no-unused-vars
const get = async (milizeToken, model, params = {}) =>
  handleAuthError(
    axios.get(`${APP_API_URL}/${model}`, {
      params,
      headers: {
        Authorization: `Bearer ${milizeToken}`,
      },
    }),
  )

// eslint-disable-next-line no-unused-vars
const del = async (milizeToken, model, params = {}) =>
  handleAuthError(
    axios.delete(`${APP_API_URL}/${model}`, {
      params,
      headers: {
        Authorization: `Bearer ${milizeToken}`,
      },
    }),
  )

const post = async (milizeToken, model, params = {}) =>
  handleAuthError(
    axios.post(`${APP_API_URL}/${model}`, params, {
      headers: {
        Authorization: `Bearer ${milizeToken}`,
      },
    }),
  )

// eslint-disable-next-line no-unused-vars
const put = async (milizeToken, model, params = {}) =>
  handleAuthError(
    axios.put(`${APP_API_URL}/${model}`, params, {
      headers: {
        Authorization: `Bearer ${milizeToken}`,
      },
    }),
  )

export const getBaseDateList = async (milizeToken, params) => post(milizeToken, `baseDateList`, params)
export const getBaseTrend = async (milizeToken, params) => post(milizeToken, `baseTrendList`, params)
export const getComparisonSimilarityList = async (milizeToken, params) => post(milizeToken, `comparisonSimilarityList`, params)
export const getEquityPriceList = async (milizeToken, params) => post(milizeToken, `equityPriceList`, params)
export const getCategoryList = async (milizeToken, params) => post(milizeToken, `equityCategoryList`, params)
export const getCategorySetList = async (milizeToken, params) => post(milizeToken, `equitySetCategoryList`, params) // AMONE
export const getEquityList = async (milizeToken, params) => post(milizeToken, `equityList`, params)
export const getEquitySetList = async (milizeToken, params) => post(milizeToken, `equitySetList`, params) // AMONE
export const getFxPriceList = async (milizeToken, params) => post(milizeToken, `fxPriceList`, params)
export const getFxSetList = async (milizeToken, params) => post(milizeToken, `fxSetList`, params)
//export const getMarketList = async (milizeToken, params) => post(milizeToken, `equityMarketList`, params)
export const getSetListCSV = async (milizeToken, params) => post(milizeToken, `getCsv`, params)
// export const updateBaseTrendList         = async (milizeToken, params) => post(milizeToken, `putBaseTrendList`, params)
export const updateCategoryList = async (milizeToken, params) => post(milizeToken, `putEquityCategoryList`, params)
export const updateEquitySetList = async (milizeToken, params) => post(milizeToken, `putEquitySetList`, params)
// export const updateFxSetList             = async (milizeToken, params) => post(milizeToken, `putFxSetListPost`, params)
export const getEquityUpdateStatus = async (milizeToken, params) => post(milizeToken, `statusOfPutEquitySetList`, params)
export const getTrendSimilarityList = async (milizeToken, params) => post(milizeToken, `trendSimilarityList`, params)

/** シナリオランキング基準日リスト */
export const getSenarioBaseDateList = async (milizeToken, params = {}) => post(milizeToken, `senario/baseDateList`, params)
/** シナリオランキングリスト */
export const getSenarioRankList = async (milizeToken, params) => post(milizeToken, `senario/rankList`, params)
